import { getBlockTitleForDisplay } from '../../../../../../../../../../lib/get-block-title-for-display'

export const getPlaceholder = (name: string) =>
  `Enter “${getBlockTitleForDisplay(name)}” here `
